import { dispatch } from "@rematch/core";
import React from "react";
import { Dropdown, Segment, Header, Grid, Icon, Button } from "semantic-ui-react";
import CountUp from "react-countup";
import LoadingComponent from "../../../../common/LoadingComponent";
import ConsumptionChart from "./ConsumptionChart";
import ConsumptionBarChart from "./ConsumptionBarChart";
import { DateRange } from "react-date-range";
import {
  startOfWeek,
  startOfMonth,
  subWeeks,
  format,
  differenceInDays,
  addDays,
  isValid,
} from "date-fns";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";

export default class ConsumptionDashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      accountTypes: [
        { key: 1, text: "All Accounts", value: "all" },
        { key: 2, text: "Freemium", value: "Free Starter Plan" },
        { key: 3, text: "Basic", value: "Basic" },
        { key: 4, text: "Standard", value: "Standard" },
        { key: 5, text: "Premium", value: "Premium" },
        { key: 6, text: "Enterprise", value: "Enterprise" },
      ],
      selectedAccountTypes: "all",
      selectedRange: "last2Weeks",
      selectedWorkspace: "all",
      selectedAccount: "all",
      selectedPreset: "last2Weeks",
      selection: [
        {
          startDate: new Date(),
          endDate: new Date(),
          key: "selection",
        },
      ],
      showDropdown: false,
      loading: false,
      isMounted: false,
      consumptionDetailsGrouped: [],
      isDatePickerOpen: false,
      consumptionDetailsChart: {
        playbooksCreated: [],
        playbooksGenerated: [],
        playbooksPublished: [],
        activitiesGenerated: [],
        playbookExported: [],
        linksGenerated: [],
        initiativeCreated: [],
        teamsCreated: [],
        scenarioExecution: [],
      },
      viewMode: false,
      consumptionCost: 0,
      mountedConsumptionDetails: null,
    };
    this.dropdownRef = React.createRef();
    this.presets = [
      { label: "Week to Date", key: "weekToDate" },
      { label: "Last Week to Date", key: "lastWeek" },
      { label: "Last 2 Weeks to Date", key: "last2Weeks" },
      { label: "Month to Date", key: "monthToDate" },
      { label: "Custom Range", key: "custom" },
    ];
  }
  handleViewChange = (mode) => {
    this.setState({ viewMode: mode });
  };

  setPreset = async (key) => {
    this.setState({ selectedRange: key });
    const today = new Date();
    let startDate = null;
    let endDate = null;

    switch (key) {
      case "weekToDate":
        startDate = startOfWeek(today, { weekStartsOn: 1 }); // Monday start
        endDate = today;
        break;
      case "lastWeek":
        startDate = subWeeks(today, 1);
        endDate = today;
        break;
      case "last2Weeks":
        startDate = subWeeks(today, 2);
        endDate = today;
        break;
      case "monthToDate":
        startDate = startOfMonth(today);
        endDate = today;
        break;
      case "custom":
        startDate = this.state.selection[0].startDate;
        endDate = this.state.selection[0].endDate;
        break;
      default:
        startDate = null;
        endDate = null;
    }
    const payload = {
      from_date: format(new Date(startDate), "yyyy-MM-dd"),
      to_date: format(new Date(endDate), "yyyy-MM-dd"),
      //   selectedAccountId: this.props.selectedAccount._id,
    };
    if (
      this.state.selectedWorkspace &&
      this.state.selectedWorkspace !== "all"
    ) {
      payload.selectedOrganizationId = this.state.selectedWorkspace;
    }
    if (this.state.selectedAccount) {
      payload.selectedAccountId = this.state.selectedAccount;
    }
    if (this.state.selectedAccountTypes) {
      payload.selectedAccountType = this.state.selectedAccountTypes;
    }
    await dispatch.account.getConsumptionDetails(payload);

    if (startDate && endDate) {
      this.setState({
        selectedPreset: key,
        selection: [
          {
            startDate,
            endDate,
            key: "selection",
          },
        ],
      });
    }
  };

  toggleDropdown = () => {
    this.setState((prev) => ({
      showDropdown: !prev.showDropdown,
    }));
  };

  handleSelect = (ranges) => {
    this.setState({ selection: ranges.selection });
    this.props.onDateChange && this.props.onDateChange(ranges.selection);
  };

  handleWorkspaceChange = (e, { value }) => {
    this.setState({ selectedWorkspace: value });
    const today = new Date();
    let startDate = null;
    let endDate = null;
    switch (this.state.selectedRange) {
      case "weekToDate":
        startDate = startOfWeek(today, { weekStartsOn: 1 }); // Monday
        endDate = today;
        break;

      case "lastWeek":
        startDate = subWeeks(today, 1);
        endDate = today; // End of that week
        break;

      case "last2Weeks":
        startDate = subWeeks(today, 2);
        endDate = today;
        break;

      case "monthToDate":
        startDate = startOfMonth(today);
        endDate = today;
        break;

      case "custom":
        startDate = new Date(this.state.selection[0].startDate);
        endDate = new Date(this.state.selection[0].endDate);
        break;

      default:
        startDate = today;
        endDate = today;
    }
    let payload = {
      from_date: startDate,
      to_date: endDate,
    };
    if (value && value !== "all") {
      payload.selectedOrganizationId = value;
    }
    if (this.state.selectedAccount && this.state.selectedAccount !== "all") {
      payload.selectedAccountId = this.state.selectedAccount;
    }
    dispatch.account.getConsumptionDetails(payload);
  };
  handleAccountChange = (e, { value }) => {
    this.setState({ selectedAccount: value, selectedWorkspace: "all" });
    const today = new Date();
    let startDate = null;
    let endDate = null;
    switch (this.state.selectedRange) {
      case "weekToDate":
        startDate = startOfWeek(today, { weekStartsOn: 1 }); // Monday
        endDate = today;
        break;

      case "lastWeek":
        startDate = subWeeks(today, 1);
        endDate = today; // End of that week
        break;

      case "last2Weeks":
        startDate = subWeeks(today, 2);
        endDate = today;
        break;

      case "monthToDate":
        startDate = startOfMonth(today);
        endDate = today;
        break;

      case "custom":
        startDate = new Date(this.state.selection[0].startDate);
        endDate = new Date(this.state.selection[0].endDate);
        break;

      default:
        startDate = today;
        endDate = today;
    }
    let payload = {
      from_date: startDate,
      to_date: endDate,
    };
    if (value && value !== "all") {
      payload.selectedAccountId = value;
    }
    dispatch.account.getConsumptionDetails(payload);
  };
  handleCustomDateChange = (item) => {
    this.setState({
      selection: [item.selection],
    });
    // let payload = {
    //   from_date:format(new Date(item.selection.startDate), 'yyyy-MM-dd'),
    //   to_date:format(new Date(item.selection.endDate), 'yyyy-MM-dd')
    // }
    // if (
    //   this.state.selectedWorkspace &&
    //   this.state.selectedWorkspace !== "all"
    // ) {
    //   payload.selectedOrganizationId = this.state.selectedWorkspace;
    // }
    // if (
    //   this.state.selectedAccount) {
    //   payload.selectedAccountId = this.state.selectedAccount;
    // }
    // if (
    //   this.state.selectedAccountTypes) {
    //   payload.selectedAccountType = this.state.selectedAccountTypes;
    // }
    // dispatch.account.getConsumptionDetails(payload);
  };
  exportConsumptionDetails = async () => {
    const today = new Date();
    let startDate = null;
    let endDate = null;
    switch (this.state.selectedRange) {
      case "weekToDate":
        startDate = startOfWeek(today, { weekStartsOn: 1 }); // Monday start
        endDate = today;
        break;
      case "lastWeek":
        startDate = subWeeks(today, 1);
        endDate = today;
        break;
      case "last2Weeks":
        startDate = subWeeks(today, 2);
        endDate = today;
        break;
      case "monthToDate":
        startDate = startOfMonth(today);
        endDate = today;
        break;
      case "custom":
        startDate = this.state.selection[0].startDate;
        endDate = this.state.selection[0].endDate;
        break;
      default:
        startDate = null;
        endDate = null;
    }
    const payload = {
      from_date: format(new Date(startDate), "yyyy-MM-dd"),
      to_date: format(new Date(endDate), "yyyy-MM-dd"),
      //   selectedAccountId: this.props.selectedAccount._id,
    };
    if (
      this.state.selectedWorkspace &&
      this.state.selectedWorkspace !== "all"
    ) {
      payload.selectedOrganizationId = this.state.selectedWorkspace;
    }
    if (this.state.selectedAccount) {
      payload.selectedAccountId = this.state.selectedAccount;
    }
    if (this.state.selectedAccountTypes) {
      payload.selectedAccountType = this.state.selectedAccountTypes;
    }
    await dispatch.account.exportConsumptionDetails(payload);
  }
  handleAccountTypeChange = (e, { value }) => {
    this.setState({
      selectedAccountTypes: value,
      selectedWorkspace: "all",
      selectedAccount: "all",
    });
    const today = new Date();
    let startDate = null;
    let endDate = null;
    switch (this.state.selectedRange) {
      case "weekToDate":
        startDate = startOfWeek(today, { weekStartsOn: 1 }); // Monday
        endDate = today;
        break;

      case "lastWeek":
        startDate = subWeeks(today, 1);
        endDate = today; // End of that week
        break;

      case "last2Weeks":
        startDate = subWeeks(today, 2);
        endDate = today;
        break;

      case "monthToDate":
        startDate = startOfMonth(today);
        endDate = today;
        break;

      case "custom":
        startDate = new Date(this.state.selection[0].startDate);
        endDate = new Date(this.state.selection[0].endDate);
        break;

      default:
        startDate = today;
        endDate = today;
    }
    let payload = {
      from_date: startDate,
      to_date: endDate,
    };
    if (value && value !== "all") {
      payload.selectedAccountType = value;
      payload.selectedAccountId = "all";
    }
    dispatch.account.getConsumptionDetails(payload);
  };
  selectedRange = (key) => {
    const today = new Date();
    let dates = [];
    let startDate = null;
    let endDate = null;

    switch (key) {
      case "weekToDate":
        startDate = startOfWeek(today, { weekStartsOn: 1 }); // Monday
        endDate = today;
        break;

      case "lastWeek":
        startDate = subWeeks(today, 1);
        endDate = today; // End of that week
        break;

      case "last2Weeks":
        startDate = subWeeks(today, 2);
        endDate = today;
        break;

      case "monthToDate":
        startDate = startOfMonth(today);
        endDate = today;
        break;

      case "custom":
        startDate = new Date(this.state.selection[0].startDate);
        endDate = new Date(this.state.selection[0].endDate);
        break;

      default:
        startDate = today;
        endDate = today;
    }

    if (isValid(startDate) && isValid(endDate)) {
      const numDays = differenceInDays(endDate, startDate) + 1;

      dates = Array.from({ length: numDays }, (_, i) =>
        format(addDays(startDate, i), "yyyy-MM-dd")
      );
    }

    return dates;
  };

  prepareExportChartData = () => {
    const dates = this.selectedRange(this.state.selectedRange);
    return dates.map((date) => {
      const formattedDate = format(new Date(date), "yyyy-MM-dd");
      const dateKey = format(new Date(date), "yyyy-MM-dd");
      return {
        date: formattedDate,
        rawDate: date,
        PlayBookExport: this.state.consumptionDetailsChart.playbookExported
          .filter(
            (item) => format(new Date(item.createdAt), "yyyy-MM-dd") === dateKey
          )
          .filter((item) => item.data.type === "PlaybookExport").length,
        WordExport: this.state.consumptionDetailsChart.playbookExported
          .filter(
            (item) => format(new Date(item.createdAt), "yyyy-MM-dd") === dateKey
          )
          .filter((item) => item.data.type === "wordExport").length,
        ExcelExport: this.state.consumptionDetailsChart.playbookExported
          .filter(
            (item) => format(new Date(item.createdAt), "yyyy-MM-dd") === dateKey
          )
          .filter((item) => item.data.type === "excelExport").length,
      };
    });
  };

  // for stashed chart
  prepareChartData = () => {
    let dates = this.selectedRange(this.state.selectedRange);

    return dates.map((date) => {
      const formattedDate = format(new Date(date), "yyyy-MM-dd");

      return {
        date: formattedDate,
        rawDate: date,
        PlaybookCreated:
          this.state.consumptionDetailsChart.playbooksCreated.filter(
            (item) => format(new Date(item.createdAt), "yyyy-MM-dd") === date
          ).length,
        PlaybookGenerated:
          this.state.consumptionDetailsChart.playbooksGenerated.filter(
            (item) => format(new Date(item.createdAt), "yyyy-MM-dd") === date
          ).length,
        PlaybookPublished:
          this.state.consumptionDetailsChart.playbooksPublished.filter(
            (item) => format(new Date(item.createdAt), "yyyy-MM-dd") === date
          ).length,
        Activities: this.state.consumptionDetailsChart.activitiesGenerated
          .filter(
            (item) => format(new Date(item.createdAt), "yyyy-MM-dd") === date
          )
          .reduce((sum, item) => sum + (item.data.activitiesGenerated || 0), 0),
        Links: this.state.consumptionDetailsChart.linksGenerated
          .filter(
            (item) => format(new Date(item.createdAt), "yyyy-MM-dd") === date
          )
          .reduce((sum, item) => sum + (item.data.linksGenerated || 0), 0),
        Exports: this.state.consumptionDetailsChart.playbookExported.filter(
          (item) => format(new Date(item.createdAt), "yyyy-MM-dd") === date
        ).length,
        Initiatives:
          this.state.consumptionDetailsChart.initiativeCreated.filter(
            (item) => format(new Date(item.createdAt), "yyyy-MM-dd") === date
          ).length,
        Teams: this.state.consumptionDetailsChart.teamsCreated.filter(
          (item) => format(new Date(item.createdAt), "yyyy-MM-dd") === date
        ).length,
        ScenarioExecution:
          this.state.consumptionDetailsChart.scenarioExecution.filter(
            (item) => format(new Date(item.createdAt), "yyyy-MM-dd") === date
          ).length,
      };
    });
  };

  //for  bar charts
  prepareBarChartData = (type) => {
    const dates = this.selectedRange(this.state.selectedRange);

    return dates.map((date) => {
      const formattedDate = format(new Date(date), "yyyy-MM-dd");
      const dateKey = format(new Date(date), "yyyy-MM-dd");

      let chartValue = 0;
      const chartData = this.state.consumptionDetailsChart;

      switch (type) {
        case "playbooksCreated":
          chartValue = chartData.playbooksCreated.filter(
            (item) => format(new Date(item.createdAt), "yyyy-MM-dd") === dateKey
          ).length;
          break;

        case "playbooksGenerated":
          chartValue = chartData.playbooksGenerated.filter(
            (item) => format(new Date(item.createdAt), "yyyy-MM-dd") === dateKey
          ).length;
          break;

        case "playbooksPublished":
          chartValue = chartData.playbooksPublished.filter(
            (item) => format(new Date(item.createdAt), "yyyy-MM-dd") === dateKey
          ).length;
          break;

        case "activitiesGenerated":
          chartValue = chartData.activitiesGenerated
            .filter(
              (item) =>
                format(new Date(item.createdAt), "yyyy-MM-dd") === dateKey
            )
            .reduce(
              (sum, item) => sum + (item.data.activitiesGenerated || 0),
              0
            );
          break;

        case "linksGenerated":
          chartValue = chartData.linksGenerated
            .filter(
              (item) =>
                format(new Date(item.createdAt), "yyyy-MM-dd") === dateKey
            )
            .reduce((sum, item) => sum + (item.data.linksGenerated || 0), 0);
          break;

        case "playbookExported":
          chartValue = chartData.playbookExported.filter(
            (item) => format(new Date(item.createdAt), "yyyy-MM-dd") === dateKey
          ).length;
          break;

        case "initiativeCreated":
          chartValue = chartData.initiativeCreated.filter(
            (item) => format(new Date(item.createdAt), "yyyy-MM-dd") === dateKey
          ).length;
          break;

        case "teamsCreated":
          chartValue = chartData.teamsCreated.filter(
            (item) => format(new Date(item.createdAt), "yyyy-MM-dd") === dateKey
          ).length;
          break;

        case "scenarioExecution":
          chartValue = chartData.scenarioExecution.filter(
            (item) => format(new Date(item.createdAt), "yyyy-MM-dd") === dateKey
          ).length;
          break;

        default:
          chartValue = 0;
      }

      return {
        date: formattedDate,
        rawDate: date,
        value: chartValue,
      };
    });
  };

  async componentDidUpdate(prevProps) {
    if (
      prevProps.consumptionDetails !== this.props.consumptionDetails &&
      this.props.consumptionDetails.length > 0
    ) {
      const grouped = {};
      for (const item of this.props.consumptionDetails) {
        const playbookId = item.playbook && item.playbook._id;
        if (!playbookId) continue;

        const activities = (item.data && item.data.activitiesGenerated) || 0;
        const links = (item.data && item.data.linksGenerated) || 0;

        if (!grouped[playbookId]) {
          grouped[playbookId] = JSON.parse(JSON.stringify(item));
          grouped[playbookId].data.activitiesGenerated = activities;
          grouped[playbookId].data.linksGenerated = links;
        } else {
          grouped[playbookId].data.activitiesGenerated += activities;
          grouped[playbookId].data.linksGenerated += links;
        }
      }

      const groupedActivities = Object.values(grouped);
      this.setState({ consumptionDetailsGrouped: groupedActivities });

      const consumptionDetailsChart = {
        playbooksCreated: this.props.consumptionDetails.filter(
          (item) => item.data.event === "PlaybookCreated"
        ),

        playbooksGenerated: this.props.consumptionDetails.filter(
          (item) => item.data.event === "PlaybookComplete"
        ),

        activitiesGenerated: this.props.consumptionDetails.filter(
          (item) => item.data.event === "PlaybookComplete"
        ),

        playbooksPublished: this.props.consumptionDetails.filter(
          (item) => item.data.event === "PlaybookPublished"
        ),

        playbookExported: this.props.consumptionDetails.filter(
          (item) => item.data.event === "PlaybookExported"
        ),

        linksGenerated: this.props.consumptionDetails.filter(
          (item) => item.data.event === "ActivityDetailsGenerated"
        ),

        initiativeCreated: this.props.consumptionDetails.filter(
          (item) => item.data.event === "InitiativeCreated"
        ),
        teamsCreated: this.props.consumptionDetails.filter(
          (item) => item.data.event === "TeamCreated"
        ),
        scenarioExecution: this.props.consumptionDetails.filter(
          (item) => item.data.event === "ScenarioExecution"
        ),
      };
      let totalCost = 0;
      for (const item of this.props.consumptionDetails) {
        totalCost += item.data.consumptionCost || 0;
      }
      this.setState({ consumptionCost: totalCost });
      this.setState({ consumptionDetailsChart });
    } else if (
      prevProps.consumptionDetails !== this.props.consumptionDetails &&
      this.props.consumptionDetails.length === 0
    ) {
      this.setState({ consumptionDetailsGrouped: [], consumptionCost: 0 });
    }
  }
  async componentWillMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
    this.setState({ loading: true });
    await this.setPreset("last2Weeks");
    const { consumptionDetails } = this.props;
    this.setState({
      loading: false,
      mountedConsumptionDetails: consumptionDetails,
    });
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }
  handleClickOutside = (event) => {
    if (
      this.dropdownRef.current &&
      !this.dropdownRef.current.contains(event.target)
    ) {
      this.setState({ showDropdown: false });
    }
  };
  render() {
    const {
      mountedConsumptionDetails,
      selectedAccount,
      selection,
      selectedPreset,
      showDropdown,
    } = this.state;
    const stashedBarConfig = [
      {
        dataKey: "PlaybookCreated",
        name: "Playbook Created Step By Step",
        fill: "#ec3a3a",
      },
      {
        dataKey: "PlaybookGenerated",
        name: "Playbook Generated With AI",
        fill: "#2599F7",
      },
      {
        dataKey: "PlaybookPublished",
        name: "Playbook Published",
        fill: "#797bfc",
      },
      {
        dataKey: "Activities",
        name: "Activities Generated",
        fill: "#8884d8",
      },
      {
        dataKey: "Links",
        name: "Links Researched",
        fill: "#82ca9d",
      },
      {
        dataKey: "Exports",
        name: "Playbooks Exported",
        fill: "#ffa600",
      },
      {
        dataKey: "Initiatives",
        name: "Projects / Initiatives Created",
        fill: "#eb7bf9",
      },
      {
        dataKey: "Teams",
        name: "Teams Created",
        fill: "#d35400",
      },
      {
        dataKey: "ScenarioExecution",
        title: "Make Scenarios Executed",
        fill: "#f4d03f",
      },
    ];

    //for Bar chart
    const chartConfig = [
      {
        key: "playbooksCreated",
        title: "Playbooks Created Step By Step",
        type: "playbooksCreated",
        color: "#ec3a3a",
      },
      {
        key: "playbooksGenerated",
        title: "Playbooks Generated With AI",
        type: "playbooksGenerated",
        color: "#2599F7",
      },
      {
        key: "playbooksPublished",
        title: "Playbooks Published",
        type: "playbooksPublished",
        color: "#797bfc",
      },
      {
        key: "playbookExported",
        title: "Playbooks Exported",
        type: "playbookExported",
        color: "#ffa600",
      },
      {
        key: "activitiesGenerated",
        title: "Activities Generated",
        type: "activitiesGenerated",
        color: "#8884d8",
      },
      {
        key: "linksGenerated",
        title: "Links Researched",
        type: "linksGenerated",
        color: "#82ca9d",
      },

      {
        key: "initiativeCreated",
        title: "Projects / Initiatives Created",
        type: "initiativeCreated",
        color: "#eb7bf9",
      },
      {
        key: "teamsCreated",
        title: "Teams Created",
        type: "teamsCreated",
        color: "#d35400",
      },
      {
        key: "scenarioExecution",
        title: "Make Scenarios Executed",
        type: "scenarioExecution",
        color: "#f4d03f",
      },
    ];

    const stashedExportBarConfig = [
      {
        dataKey: "PlayBookExport",
        name: "Playbook Exported",
        fill: "#ffa600",
      },
      {
        dataKey: "WordExport",
        name: "Word Exported",
        fill: "#ef5675",
      },
      {
        dataKey: "ExcelExport",
        name: "Excel Created",
        fill: "#7a5195",
      },
    ];
    let orgList =
      (mountedConsumptionDetails &&
        Array.from(
          new Map(
            mountedConsumptionDetails
              .filter(
                (con) =>
                  selectedAccount &&
                  selectedAccount !== "all" &&
                  selectedAccount === con.account._id
              )
              .map((org) => [
                org.organization._id,
                {
                  key: org.organization._id,
                  text: org.organization.name,
                  value: org.organization._id,
                },
              ])
          ).values()
        )) ||
      [];
    orgList.unshift({
      key: "all",
      text: "All Workspaces",
      value: "all",
    });
    orgList = orgList.filter((item) => item.key && item.value);

    const consumptionData =
      this.state.selectedAccountTypes &&
      this.state.selectedAccountTypes !== "all"
        ? mountedConsumptionDetails.filter((con) =>
            con.account.planDisplayName
              .toLowerCase()
              .includes(this.state.selectedAccountTypes.toLowerCase())
          )
        : mountedConsumptionDetails;
    let accList =
      (consumptionData &&
        Array.from(
          new Map(
            consumptionData.map((acc) => [
              acc.account._id,
              {
                key: acc.account._id,
                text: acc.account.name,
                value: acc.account._id,
              },
            ])
          ).values()
        )) ||
      [];
    accList.unshift({
      key: "all",
      text: "All Accounts",
      value: "all",
    });
    accList = accList.filter((item) => item.key && item.value);
    return (
      <div>
        <LoadingComponent
          active={this.props.loadingConsumptions || this.state.loading}
          message="Loading Consumption Details"
        />
        <Segment padded>
          <Header as="h4"><div style={{display:"flex", justifyContent:"space-between", alignItems:"center"}}><span>Consumption Dashboard </span><Button
                              style={{
                                  backgroundColor: '#2185d0',
                                  color: 'white',
                                  borderRadius: '3px',
                                  fontSize: '13px',
                                  width: '200px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  gap: '2px',
                                  float:'right',
                                  marginRight: '10px'
                              }}
                              onClick={this.exportConsumptionDetails}
                              >
                              <Icon name="cloud download" color="white"/>
                              Consumption Details
                          </Button></div>
                          </Header>
          <div style={{ display: "flex" }}>
            <div style={{ width: "100%" }}>
              <div>
                <div
                  style={{
                    display: "flex",
                    gap: "1em",
                    marginBottom: "1em",
                    alignItems: "center",
                    flexWrap: "wrap",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      width: "30%",
                      gap: "0.3em",
                    }}
                  >
                    <label style={{ marginRight: "5px" }}>
                      <strong>Account Types</strong>
                    </label>
                    <Dropdown
                      placeholder="Select Account Type"
                      selection
                      options={this.state.accountTypes}
                      value={this.state.selectedAccountTypes}
                      onChange={this.handleAccountTypeChange}
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      width: "30%",
                      gap: "0.3em",
                    }}
                  >
                    <label style={{ marginRight: "5px" }}>
                      <strong>Accounts</strong>
                    </label>
                    <Dropdown
                      placeholder="Select Account"
                      selection
                      options={accList}
                      value={this.state.selectedAccount}
                      onChange={this.handleAccountChange}
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      width: "30%",
                      gap: "0.3em",
                    }}
                  >
                    <label style={{ marginRight: "5px" }}>
                      <strong>Workspace</strong>
                    </label>
                    <Dropdown
                      placeholder="Select Workspace"
                      selection
                      options={orgList}
                      value={this.state.selectedWorkspace}
                      onChange={this.handleWorkspaceChange}
                      disabled={
                        this.state.selectedAccount === "all" ||
                        this.state.selectedAccount === ""
                      }
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      width: "30%",
                      gap: "0.3em",
                    }}
                  >
                    <label style={{ marginRight: "5px" }}>
                      <strong>Select Date Range</strong>
                    </label>
                    <div className="date-range-selector-wrapper">
                      <button
                        className="dropdown-trigger"
                        onClick={this.toggleDropdown}
                      >
                        {selection[0].startDate && selection[0].endDate
                          ? `${format(
                              selection[0].startDate,
                              "MMM d, yyyy"
                            )} - ${format(selection[0].endDate, "MMM d, yyyy")}`
                          : "Select Date Range"}
                      </button>

                      {showDropdown && (
                        <div
                          className="popup-dropdown-overlay"
                          onClick={this.toggleDropdown}
                        >
                          <div
                            className="popup-dropdown"
                            ref={this.dropdownRef}
                            onClick={(e) => e.stopPropagation()}
                          >
                            <div className="date-range-dropdown">
                              <div className="presets-list">
                                {this.presets.map((preset) => (
                                  <div
                                    key={preset.key}
                                    className={`preset-item ${
                                      selectedPreset === preset.key
                                        ? "active"
                                        : ""
                                    }`}
                                    onClick={() => this.setPreset(preset.key)}
                                  >
                                    {preset.label}
                                    {selectedPreset !== "custom" &&
                                      selectedPreset === preset.key && (
                                        <div className="preset-dates">
                                          {`${
                                            selection[0].startDate &&
                                            format(
                                              selection[0].startDate,
                                              "MMM d"
                                            )
                                          } - ${
                                            selection[0].endDate &&
                                            format(
                                              selection[0].endDate,
                                              "MMM d"
                                            )
                                          }`}
                                        </div>
                                      )}
                                  </div>
                                ))}
                              </div>

                              <div className="calendar-container">
                                <DateRange
                                  onChange={(item) =>
                                    this.handleCustomDateChange(item)
                                  }
                                  showSelectionPreview={true}
                                  moveRangeOnFirstSelection={false}
                                  months={2}
                                  ranges={selection}
                                  direction="horizontal"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <div
                style={{
                  height: "20px",
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <div>
                  <Header as="h5">
                    {
                      orgList.find(
                        (org) => org.value === this.state.selectedWorkspace
                      ).text
                    }{" "}
                    -{" "}
                    {
                      this.presets.find(
                        (opt) => opt.key === this.state.selectedRange
                      ).label
                    }
                  </Header>
                </div>
                <div
                  style={{
                    marginLeft: "10px",
                    display: "flex",
                    alignItems: "center",
                    padding: "2px",
                  }}
                ></div>
              </div>
              <Grid
                columns="equal"
                celled="internally"
                className="count-block-item setHoverEffect"
                style={{ margin: "20px 0px 0px 0px", border:"1px solid #d4d4d5", borderRadius:"5px"}}
              >
                <Grid.Row>
                  <Grid.Column>
                    <CountUp end={this.props.playbooksCreated} duration={5} />
                    <label>Playbooks Generated With AI</label>
                  </Grid.Column>
                  <Grid.Column>
                    <CountUp
                      end={this.props.activitiesGenerated}
                      duration={5}
                    />
                    <label>Activities Generated</label>
                  </Grid.Column>
                  <Grid.Column>
                    <CountUp end={this.props.linksGenerated} duration={5} />
                    <label>Links Researched</label>
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                                <Grid.Column>
                                    {/* {this.props.isLoadingData ? */}
                                        <CountUp end={this.state.consumptionDetailsChart.playbooksCreated ? this.state.consumptionDetailsChart.playbooksCreated.length : 0} duration={5} />
                                        {/* <span>{30}</span> */}
                                    {/* } */}
                                    <label>Total Playbooks Created Step By Step</label>
                                </Grid.Column>
                                <Grid.Column>
                                    {/* {this.props.isLoadingData ? */}
                                        <CountUp end={this.state.consumptionDetailsChart.playbooksPublished ? this.state.consumptionDetailsChart.playbooksPublished.length : 0} duration={5} />
                                        {/* <span>{30}</span> */}
                                    {/* } */}
                                    <label>Total Playbooks Published</label>
                                </Grid.Column>
                                <Grid.Column>
                                    {/* {this.props.isLoadingData ? */}
                                        <CountUp end={this.state.consumptionDetailsChart.initiativeCreated ? this.state.consumptionDetailsChart.initiativeCreated.length : 0} duration={5} />
                                        {/* <span>{30}</span> */}
                                    {/* } */}
                                    <label>Total Projects/Initiatives Created</label>
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row>
                                <Grid.Column>
                                    {/* {this.props.isLoadingData ? */}
                                        <CountUp end={this.state.consumptionDetailsChart.playbookExported ? this.state.consumptionDetailsChart.playbookExported.length : 0} duration={5} />
                                        {/* <span>{30}</span> */}
                                    {/* } */}
                                    <label>Total Playbooks Exported</label>
                                </Grid.Column>
                                <Grid.Column>
                                    {/* {this.props.isLoadingData ? */}
                                        <CountUp end={this.state.consumptionDetailsChart.teamsCreated ? this.state.consumptionDetailsChart.teamsCreated.length : 0} duration={5} />
                                        {/* <span>{30}</span> */}
                                    {/* } */}
                                    <label>Total Teams Created</label>
                                </Grid.Column>
                                <Grid.Column>
                                    {/* {this.props.isLoadingData ? */}
                                        <CountUp end={this.state.consumptionDetailsChart.scenarioExecution ? this.state.consumptionDetailsChart.scenarioExecution.length : 0} duration={5} />
                                        {/* <span>{30}</span> */}
                                    {/* } */}
                                    <label>Total Make Scenarios Executed</label>
                                </Grid.Column>
                            </Grid.Row>
              </Grid>
              {!this.state.viewMode && (
                <div
                  style={{
                    height: "calc(100vh - 200px)",
                    width: "100%",
                    overflowY: "auto",
                    overflowX: "hidden",
                    paddingRight: "10px",
                    marginTop: "10px",
                  }}
                >
                  <div style={{ marginTop: "10px", width: "100%" }}>
                    <div
                      style={{
                        overflowX: "auto",
                        overflowY: "hidden",
                        width: "100%",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <div
                        style={{
                          minWidth: ["weekToDate", "lastWeek"].includes(
                            this.state.selectedRange
                          )
                            ? "100%"
                            : ["last2Weeks"].includes(this.state.selectedRange)
                            ? "500px"
                            : "900px",
                          width: "95%",
                          height: "350px",
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <div
                          style={{
                            fontWeight: "bold",
                            fontSize: "12px",
                            transform: "translateX(35px)",
                            width: "20%",
                          }}
                        >
                          Total Spend - ${this.state.consumptionCost}
                        </div>
                        <ConsumptionChart
                          prepareChartData={this.prepareChartData}
                          chartConfig={stashedBarConfig}
                          height={350}
                        />
                      </div>
                    </div>
                  </div>
                  <div style={{ marginTop: "10px", width: "100%" }}>
                    <div
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "10px 15px",
                      }}
                    >
                      {chartConfig.map((chart) => (
                        <div
                          key={chart.key}
                          style={{
                            width: "calc(50% - 10px)",
                            display: "flex",
                            flexDirection: "column",
                            padding: "2px",
                          }}
                        >
                          <div
                            style={{
                              fontWeight: "bold",
                              fontSize: "12px",
                              transform: "translateX(35px)",
                            }}
                          >
                            {chart.title}
                          </div>
                          <div
                            style={{ overflowX: "auto", overflowY: "hidden" }}
                          >
                            <div
                              style={{
                                // minWidth: ["weekToDate", "lastWeek"].includes(
                                //   this.state.selectedRange
                                // )
                                //   ? "100%"
                                //   : ["last2Weeks"].includes(
                                //       this.state.selectedRange
                                //     )
                                //   ? "480px"
                                //   : "1000px",
                                height: "300px",
                              }}
                            >
                              {chart.key === "playbookExported" ? (
                                <ConsumptionChart
                                  prepareChartData={this.prepareExportChartData}
                                  chartConfig={stashedExportBarConfig}
                                  height={300}
                                />
                              ) : (
                                <ConsumptionBarChart
                                  type={chart.type}
                                  title={chart.title}
                                  color={chart.color}
                                  prepareBarChartData={this.prepareBarChartData}
                                />
                              )}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </Segment>
      </div>
    );
  }
}
